import { IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';
import { sendDwh } from 'reactApp/utils/ga';

type sendPublicPasswordAnalyticsArgs = {
    paid_user?: boolean;
    eventCategory?: string;
    action: string;
};

export enum PublicPasswordEventCategory {
    passwordFolder = 'password-folder',
    deletePassword = 'delete-password',
    tooltipPassword = 'tooltip-password',
    publicFolderGuest = 'password-folder-guest',
}

export const sendPublicPasswordAnalytics = ({
    eventCategory = PublicPasswordEventCategory.passwordFolder,
    action,
    paid_user,
}: sendPublicPasswordAnalyticsArgs) => {
    sendDwh({
        eventCategory,
        action,
        dwhData: {
            paid_user,
            source: IS_MOBILE_BROWSER ? 'touch' : 'desktop',
        },
    });
};
